/*
 * ${locale}.resources.${resourceName}.name for resource names (used for the menu and page titles)
 * ${ locale }.resources.${ resourceName }.fields.${ fieldName } for field names(used for datagrid header and form input labels)
 */

export default {
    'unauthorised-action': 'Esta es una acción no autorizada',
    actions: {
        add: 'Añadir',
        cancel: 'Cancelar',
        close: 'Cerca',
        create: 'Crear',
        configure: 'Configurar',
        confirm: 'Confirmar',
        deduct: 'Deducir',
        delete: 'Borrar',
        duplicate: 'Duplicar',
        edit: 'Editar',
        export: 'Exportar',
        generated: 'Generado',
        goBack: 'Regresa',
        hide: 'Ocultar',
        import: 'Importar',
        invite: 'Invitar',
        list: 'Lista',
        no: 'No',
        ok: 'Okay',
        pause: 'Pausa',
        refresh: 'Actualizar',
        refund: 'Reembolsar',
        reset: 'Valores claros',
        resume: 'Reanudar',
        retry: 'Procesar de nuevo',
        returnTo: 'Volver a',
        returnToThe: 'Volver a la',
        save: 'Save',
        search: 'Buscar',
        show: 'Mostrar',
        signIn: 'Registrarse',
        submit: 'Enviar',
        submit_add_another: 'Guardar y agregar siguiente',
        terminate: 'Terminar',
        translate: 'Traducir',
        yes: 'Sí',
    },
    auth: {
        forgotPassword: {
            actions: {
                iRemember: 'Yo recuerdo',
                resetPassword: 'Restablecer la contraseña',
            },
            fields: {
                email: 'Correo electrónico',
            },
            notifications: {
                success: 'Si pudiéramos encontrar su cuenta, recibirá pronto un correo electrónico.',
            },
            title: '¿Olvidaste tu contraseña?',
        },
        login: {
            fields: {
                email: 'Correo electrónico',
                password: 'Contraseña',
            },
            notifications: {
                failure: 'Credenciales no válidas',
            },
            noCookies: {
                description: 'Las cookies no están habilitadas en su navegador. Habilite las cookies en las preferencias de su navegador para continuar.',
                title: 'galletas requeridas',
            },
        },
        logout: {
            description: '¿Estás seguro que deseas salir?',
            title: 'Cerrar sesión',
            notifications: {
                failure: 'No se pudo cerrar la sesión de su cuenta.',
                success: 'Su cuenta se ha cerrado con éxito',
            },
        },
    },
    components: {
        autocomplete: {
            hinttext: 'Escriba para comenzar la búsqueda',
        },
    },
    countries: {
        AD: 'Andorra',
        AE: 'Emiratos Árabes Unidos',
        AF: 'Afganistán',
        AG: 'Antigua y Barbuda',
        AI: 'Anguila',
        AL: 'Albania',
        AM: 'Armenia',
        AO: 'Angola',
        AQ: 'Antártida',
        AR: 'Argentina',
        AS: 'Samoa Americana',
        AT: 'Austria',
        AU: 'Australia',
        AW: 'Aruba',
        AX: 'Islas Aland',
        AZ: 'Azerbaiyán',
        BA: 'Bosnia y Herzegovina',
        BB: 'Barbados',
        BD: 'Bangladesh',
        BE: 'Bélgica',
        BF: 'Burkina Faso',
        BG: 'Bulgaria',
        BH: 'Bahrein',
        BI: 'Burundi',
        BJ: 'Benin',
        BL: 'San Bartolomé',
        BM: 'islas Bermudas',
        BN: 'Brunei',
        BO: 'Bolivia',
        BQ: 'Bonaire, San Eustaquio y Saba',
        BR: 'Brasil',
        BS: 'Bahamas',
        BT: 'Bután',
        BV: 'Isla Bouvet',
        BW: 'Botsuana',
        BY: 'Bielorrusia',
        BZ: 'Belice',
        CA: 'Canadá',
        CC: 'Islas Cocos',
        CD: 'República Democrática del Congo',
        CF: 'República Centroafricana',
        CG: 'República del congo',
        CH: 'Suiza',
        CI: 'Costa de Marfil',
        CK: 'Islas Cook',
        CL: 'Chile',
        CM: 'Camerún',
        CN: 'China',
        CO: 'Colombia',
        CR: 'Costa Rica',
        CU: 'Cuba',
        CV: 'Cabo Verde',
        CW: 'Curacao',
        CX: 'Isla de Navidad',
        CY: 'Chipre',
        CZ: 'Republica checa',
        DE: 'Alemania',
        DJ: 'Djibouti',
        DK: 'Dinamarca',
        DM: 'Dominica',
        DO: 'República Dominicana',
        DZ: 'Argelia',
        EC: 'Ecuador',
        EE: 'Estonia',
        EG: 'Egipto',
        EH: 'Sahara Occidental',
        ER: 'Eritrea',
        ES: 'España',
        ET: 'Etiopía',
        FI: 'Finlandia',
        FJ: 'Fiyi',
        FK: 'Islas Malvinas',
        FM: 'Micronesia',
        FO: 'Islas Faroe',
        FR: 'Francia',
        GA: 'Gabón',
        GB: 'Reino Unido',
        GD: 'Granada',
        GE: 'Georgia',
        GF: 'Guayana Francesa',
        GG: 'Guernsey',
        GH: 'Ghana',
        GI: 'Gibraltar',
        GL: 'Groenlandia',
        GM: 'Gambia',
        GN: 'Guinea',
        GP: 'Guadalupe',
        GQ: 'Guinea Ecuatorial',
        GR: 'Grecia',
        GS: 'Georgia del sur y las islas Sandwich del sur',
        GT: 'Guatemala',
        GU: 'Guam',
        GW: 'Guinea-Bissau',
        GY: 'Guayana',
        HK: 'Hong Kong',
        HM: 'Islas Heard y McDonald',
        HN: 'Honduras',
        HR: 'Croacia',
        HT: 'Haití',
        HU: 'Hungría',
        ID: 'Indonesia',
        IE: 'Irlanda',
        IL: 'Israel',
        IM: 'Isla del hombre',
        IN: 'India',
        IO: 'Territorio Británico del Océano Índico',
        IQ: 'Irak',
        IR: 'Corrí',
        IS: 'Islandia',
        IT: 'Italia',
        JE: 'Jersey',
        JM: 'Jamaica',
        JO: 'Jordán',
        JP: 'Japón',
        KE: 'Kenia',
        KG: 'Kirguistán',
        KH: 'Camboya',
        KI: 'Kiribati',
        KM: 'Comoras',
        KN: 'San Cristóbal y Nieves',
        KP: 'Corea del Norte',
        KR: 'Corea del Sur',
        KW: 'Kuwait',
        KY: 'Islas Caimán',
        KZ: 'Kazajstán',
        LA: 'Laos',
        LB: 'Líbano',
        LC: 'Santa Lucía',
        LI: 'Liechtenstein',
        LK: 'Sri Lanka',
        LR: 'Liberia',
        LS: 'Lesoto',
        LT: 'Lituania',
        LU: 'Luxemburgo',
        LV: 'Letonia',
        LY: 'Libia',
        MA: 'Marruecos',
        MC: 'Mónaco',
        MD: 'Moldavia',
        ME: 'Montenegro',
        MF: 'San Martín',
        MG: 'Madagascar',
        MH: 'Islas Marshall',
        MK: 'macedonia',
        ML: 'Mali',
        MM: 'Myanmar',
        MN: 'Mongolia',
        MO: 'Macao',
        MP: 'Islas Marianas del Norte',
        MQ: 'Martinica',
        MR: 'Mauritania',
        MS: 'Montserrat',
        MT: 'Malta',
        MU: 'Mauricio',
        MV: 'Maldivas',
        MW: 'Malawi',
        MX: 'Mexico',
        MY: 'Malasia',
        MZ: 'Mozambique',
        NA: 'Namibia',
        NC: 'Nueva Caledonia',
        NE: 'Níger',
        NF: 'Isla Norfolk',
        NG: 'Nigeria',
        NI: 'Nicaragua',
        NL: 'Países Bajos',
        NO: 'Noruega',
        NP: 'Nepal',
        NR: 'Nauru',
        NU: 'Niue',
        NZ: 'Nueva Zelanda',
        OM: 'Omán',
        PA: 'Panamá',
        PE: 'Perú',
        PF: 'Polinesia francés',
        PG: 'Papúa Nueva Guinea',
        PH: 'Filipinas',
        PK: 'Pakistán',
        PL: 'Polonia',
        PM: 'San Pedro y Miquelón',
        PN: 'Pitcairn',
        PR: 'Puerto Rico',
        PS: 'Territorio Palestino',
        PT: 'Portugal',
        PW: 'Palau',
        PY: 'Paraguay',
        QA: 'Katar',
        RE: 'Reunión',
        RO: 'Rumania',
        RS: 'Serbia',
        RU: 'Rusia',
        RW: 'Ruanda',
        SA: 'Arabia Saudita',
        SB: 'Islas Salomón',
        SC: 'Seychelles',
        SD: 'Sudán',
        SE: 'Suecia',
        SG: 'Singapur',
        SH: 'Santa Elena',
        SI: 'Eslovenia',
        SJ: 'Svalbard y Jan Mayen',
        SK: 'Eslovaquia',
        SL: 'Sierra Leona',
        SM: 'San Marino',
        SN: 'Senegal',
        SO: 'Somalia',
        SR: 'Surinam',
        SS: 'Sudán del Sur',
        ST: 'Santo Tomé y Príncipe',
        SV: 'El Salvador',
        SX: 'Sint Maarten',
        SY: 'Siria',
        SZ: 'Swazilandia',
        TC: 'Islas Turcas y Caicos',
        TD: 'Chad',
        TF: 'Territorios Franceses del Sur',
        TG: 'Ir',
        TH: 'Tailandia',
        TJ: 'Tayikistán',
        TK: 'Tokelau',
        TL: 'Timor Oriental',
        TM: 'Turkmenistán',
        TN: 'Túnez',
        TO: 'Tonga',
        TR: 'pavo',
        TT: 'Trinidad y Tobago',
        TV: 'Tuvalu',
        TW: 'Taiwán',
        TZ: 'Tanzania',
        UA: 'Ucrania',
        UG: 'Uganda',
        UM: 'Islas ultramarinas menores de Estados Unidos',
        US: 'Estados Unidos',
        UY: 'Uruguay',
        UZ: 'Uzbekistán',
        VA: 'Vaticano',
        VC: 'San Vicente y las Granadinas',
        VE: 'Venezuela',
        VG: 'Islas Vírgenes Británicas',
        VI: 'Islas Vírgenes de EE.UU',
        VN: 'Vietnam',
        VU: 'Vanuatu',
        WF: 'Wallis y Futuna',
        WS: 'Samoa',
        XK: 'Kosovo',
        YE: 'Yemen',
        YT: 'Mayotte',
        ZA: 'Sudáfrica',
        ZM: 'Zambia',
        ZW: 'Zimbabue',
    },
    elements: {
        confirm: {
            description: 'No podrás editar los productos de subscripción después de esta acción.',
            title: '¿Estás seguro de que deseas confirmar esta subscription?',
        },
        delete: {
            description: 'El artículo será eliminado permanentemente. Esta acción no se puede deshacer.',
            title: '¿Estás seguro de que deseas eliminar esto?',
        },
        outdatedBrowser: {
            description: 'Nuestra herramienta Dashboard no es compatible con la versión actual de su navegador. Para una mejor experiencia al usar este sitio web, actualice su navegador a la última versión.',
            linkText: 'Haz click aquí para descubrir como',
            title: '¡Mejora tu experiencia en el Dashboard!',
        },
        terminate: {
            description: 'La subscripión será terminada permanentemente.',
            title: '¿Estás seguro de que deseas terminar la subscripción?',
        },
    },
    export: {
        error: {
            maximum_reached: 'Pero nuestras exportaciones no pueden contener más de 15.000 reservas. Puede agregar más filtros para disminuir el número de reservas o continuar y exportar los primeros 15.000 resultados.',
            title: 'Sabíamos que tienes éxito...',
        },
        description: 'Seleccione qué campos le gustaría ver en su exportación',
        notifications: {
            empty_filters: {
                description: 'Esto requiere la aplicación de uno o más filtros. Aplica uno o más filtros para realizar una exportación.',
                title: 'Nos faltan filtros',
            },
        },
        title: 'Preparando exportación',
        field_groups: {
            booking: 'Detalles de reserva',
            consumer: 'Consumidor',
            customer: 'Detalles del cliente',
            default: 'Defecto',
            financial: 'Detalles financieros',
            payment_method: 'Método de pago',
            product: 'Producto',
            user_attributes: 'Atributos de usuario',
        },
        fields: {
            administration_fee: 'Cuota de administracion',
            amount: 'Amount',
            arrival_date: 'Fecha de llegada',
            booking_date: 'Fecha para registrarse',
            costfree_cancellation: 'Seguro de cancelación',
            currency: 'Moneda',
            customer_email: 'Correo electrónico del cliente',
            customer_first_name: 'Nombre del cliente',
            customer_last_name: 'Apellido del cliente',
            customer_license_plate: 'Matrícula del cliente',
            customer_phone: 'Teléfono del cliente',
            customer_remarks: 'Observaciones del cliente',
            departure_date: 'Fecha de salida',
            discount_amount: 'Importe de descuento',
            discount_company_name: 'Nombre de la empresa de descuento',
            discount_owner_id: 'ID de propietario de descuento',
            discount_title: 'Nombre de descuento',
            email: 'Email',
            first_name: 'Nombre',
            gateway: 'Portal',
            has_failed_invoice: 'Ha fallado la factura',
            id: 'ID',
            internal_order_id: 'Solicitar ID',
            invoiced_at: 'Facturado en',
            last_name: 'Apellido',
            locale: 'Idioma',
            method: 'Método',
            number_of_persons: 'Número de personas',
            options_price: 'Precio de opciones',
            order_id: 'Solicitar ID',
            payment_amount_paid: 'Importe del pago pagado',
            payment_method: 'Payment method',
            payment_method_status: 'Payment method status',
            price_membership_deduction: 'Membership deduction',
            payment_status: 'Estado de pago',
            phone: 'Número de teléfono',
            price: 'Precio',
            product_address: 'Dirección del producto',
            product_id: 'Identificación de producto',
            product: 'Producto',
            provider_id: 'ID del proveedor',
            provider_price_total: 'Precio total del proveedor',
            provider_price: 'Precio del proveedor',
            provider: 'Proveedor',
            reseller_funnel: 'Revendedor embudo',
            reseller_id: 'ID del revendedor',
            reseller_price_total: 'Precio total del revendedor',
            reseller_price: 'Precio del revendedor',
            reseller: 'Revendedores',
            reservation_status: 'Estado de la reserva',
            return_flight_number: 'Número de vuelo de regreso',
            status: 'Estado',
            transaction_fee: 'Tarifa de transacción',
            yield_price: 'Precio de rendimiento',
        },
    },
    fields: {
        currency: 'Moneda',
        dates: 'Fecha',
        datetime: {
            never: 'Nunca',
        },
        empty: 'Desconocido',
        ends_at: 'Termina en',
        full: 'Total',
        is_scheduled: 'Programado',
        none: 'Ninguno',
        optional: '(Opcional)',
        other: 'Otro',
        percentage: 'Porcentaje',
        price: 'Precio',
        price_original: 'Precio original',
        reason: 'Motivo',
        size: 'Tamaño',
        starts_at: 'Comienza en',
        updated: 'Actualizado',
        weekday: {
            1: 'Lunes',
            2: 'Martes',
            3: 'Miércoles',
            4: 'Jueves',
            5: 'Viernes',
            6: 'Sábado',
            7: 'Domingo',
        },
    },
    forms: {
        email: 'Debe ser un correo electrónico',
        error: {
            'location-not-found': 'No se pudo encontrar la ubicación',
            'location-could-not-be-resolved': 'No se pudo encontrar la ubicación',
            'the-id-format-is-invalid': 'El formato de identificación no es válido',
        },
        invalid: {
            discount_rule: 'Regla de descuentos no válida',
            email: 'Email inválido',
            first_name: 'Nombre inválido',
            general: 'Caracteres inválidos',
            last_name: 'Apellido no válido',
            phone: 'Este es un número de teléfono no válido',
            max_characters: 'Debe tener %{max} caracteres o menos',
            url: 'Esta es una URL inválida',
            match: 'The value with %{field} does not match',
        },
        localisation: {
            available: {
                title: 'Añadir un idioma',
            },
            origin: {
                description: '¿Desea traducir los textos actuales de %{locale} a %{target}?',
                title: 'Traducir del %{source}',
            },
            update: {
                description: '¿Desea traducir los textos actuales de %{locale} a %{target}?',
                description_2: 'La traducción sobrescribirá los textos actuales %{target}.',
                description_3: 'No se guardan hasta que envíe el formulario.',
                inactive: 'Agregue el texto en %{locale} antes de poder traducir a este idioma.',
                title: 'Traducir al inglés',
            },
            required: {
                description: 'Es obligatorio ingresar todos los textos en inglés antes de poder agregar otros idiomas.',
                title: 'Añadir un idioma',
            },
        },
        no_results: 'No se agregaron descripciones a este producto.',
        number: 'Tiene que ser un número',
        one_of_them_required: 'Por favor, rellene uno de estos campos.',
        required: 'Necesario',
        submit: {
            required: '%{locale} - %{key} es requerido',
        },
    },
    filters: {
        add: 'Agregar un filtro',
        category: {
            advanced: 'avanzado',
            basic: 'básico',
        },
        clear_all_filters: 'Borrar todos los filtros',
        components: {
            accountId: {
                label: 'Cuenta',
            },
            booking: {
                label: 'Reserva',
            },
            bookingOrderId: {
                label: 'Id. de orden de reserva',
            },
            bookingReservationOrderId: {
                label: 'ID de pedido de reserva',
            },
            cancelled: {
                label: 'Cancelada',
            },
            cancelledAt: {
                label: 'Cancelado en',
                placeholder: 'Elige una fecha',
            },
            categoryId: {
                label: 'Categoría',
                placeholder: 'Elige una categoría',
            },
            createdAt: {
                label: 'Creado en',
                placeholder: 'Elige una fecha',
            },
            companyName: {
                label: 'Nombre de empresa',
            },
            currencies: {
                label: 'Monedas',
                placeholder: 'Elija una moneda',
            },
            destinationArrivalDate: {
                label: 'Fecha de llegada',
                placeholder: 'Inicio (llegada al destino)',
            },
            destinationDepartureDate: {
                label: 'Fecha de salida',
                placeholder: 'Fin (salida del destino)',
            },
            email: {
                label: 'Correo electrónico',
            },
            enabled: {
                choices: {
                    active: 'Solo activo',
                    inactive: 'Solo inactivo',
                },
                label: 'Habilitado',
            },
            end_date_null_or_from: {
                label: 'Terminado desde',
            },
            funnelId: {
                label: 'Campañas',
            },
            lastName: {
                label: 'Apellido',
            },
            licensePlate: {
                label: 'License plate',
            },
            name: {
                label: 'Name',
            },
            orderId: {
                label: 'Orden ID',
            },
            interval: {
                choices: {
                    day: 'día',
                    month: 'mes',
                    week: 'semana',
                    year: 'año',
                },
                label: 'Intervalo',
            },
            invoice: {
                label: 'Factura',
            },
            is_rebooked: {
                choices: {
                    active: 'Solo rereservado',
                    inactive: 'Solo no rereservado',
                },
                label: 'Rereservado',
            },
            is_terminated: {
                label: 'Terminado',
            },
            paymentStatus: {
                choices: {
                    chargedback: 'Cargado de vuelta',
                    deferred: 'Diferido',
                    failed: 'Ha fallado',
                    inProgress: 'En progreso',
                    refunded: 'Reintegrado',
                    success: 'Exitoso',
                    unknown: 'Desconocido',
                },
                label: 'Estado de pago',
                placeholder: 'Seleccione su pago',
            },
            phone: {
                label: 'Número de teléfono',
            },
            pointOfInterestId: {
                label: 'Punto de interés',
            },
            productId: {
                label: 'Producto',
            },
            providerId: {
                label: 'Proveedor',
            },
            resellerId: {
                label: 'Revendedores',
            },
            reservationStatus: {
                choices: {
                    awaiting: 'Pendiente',
                    canceled: 'Cancelado',
                    completed: 'Terminado',
                    error: 'Error',
                    pending: 'Pendiente',
                    split: 'Dividir',
                    underReview: 'Bajo revisión',
                },
                label: 'Estado de reserva',
            },
            subcategoryId: {
                label: 'Subcategoría',
                placeholder: 'Subcategoría',
            },
            status: {
                label: 'Estado',
            },
            testBooking: {
                choices: {
                    real: 'Sólo real',
                    test: 'Solo prueba',
                },
                label: 'Tipo de reserva',
            },
            userId: {
                label: 'Usuario',
            },
            product_membership_id: {
                label: 'Membresía de producto',
            },
            user_product_membership_pool_id: {
                label: 'Grupo de membresía de producto',
            },
            usesDiscountCodes: {
                choices: {
                    active: 'Utilice códigos de descuento',
                    inactive: 'No hay códigos de descuento',
                },
                label: 'Utiliza códigos de descuento',
            },
        },
        title: 'Filtros',
        matchtype: 'Tipo de concordancia',
        matchtypes: {
            between: 'Entre',
            contains: 'Contiene',
            ends_with: 'Termina con',
            equals: 'Igual a',
            match_all_of: 'Unir todos',
            match_one_of: 'Coincide con uno de',
            near: 'Cerca',
            range: 'Dentro',
            starts_with: 'Comienza con',
        },
    },
    general: {
        data_updated: 'Datos actualizados',
        error: 'Algo salió mal, por favor intente nuevamente más tarde ...',
        images: 'Imágenes',
        loading: 'Cargando...',
        noMatches: 'No se pudo encontrar ningún partido',
    },
    impersonation: {
        actions: {
            log_in: 'Personificar',
            log_out: 'Volver a tu cuenta',
        },
        logged_in: 'Actualmente estás conectado como %{name}.',
    },
    languages: {
        dutch: 'Holandés',
        english: 'Inglés',
        german: 'Alemán',
        french: 'Francés',
        italian: 'Italiano',
        spanish: 'Español',
    },
    localisations: {
        dialog: {
            label: 'Seleccione un idioma disponiblee',
        },
    },
    dropzone: {
        label: {
            button: 'Subir logo',
            button_image: 'Subir imagen',
            description_file_max: 'Tamaño máx. de archivo: %{max} KB',
            description_max: 'Altura máx.: %{height}px, Ancho máx.: %{width}px',
            description_min: 'Altura min.: %{height}px, Ancho min.: %{width}px',
            format: 'Formato aceptado: %{format}',
            highlight_image: 'Resaltar imagen',
            highlighted_image: 'Imagen resaltada',
            remove_highlight: 'Eliminar lo resaltado',
            text: 'Haz clic o arrastra una imagen',
        },
    },
    menu: {
        sidebar: {
            assets: 'Assets',
            access_points: 'Puntos de acceso',
            accounts: 'Cuentas',
            account_administration: 'Administración de cuentas',
            account_details: 'Detalles de la cuenta',
            account_yields: 'Flexible',
            all_users: 'Todos los usuarios',
            'api-keys': 'API keys',
            bookingStats: 'Estadística',
            bookings: 'Reservas',
            campaigns: 'Campañas',
            content: 'Contenido',
            dashboard: 'Tablero de instrumentos',
            discounts: 'Descuentos',
            internal_yield_service_user: 'Rendimientos',
            invoices: 'Facturas',
            legaldocuments: {
                engagement_agreement: 'Acuerdo de compromiso',
                main: 'Documentos legales',
                privacy_statement: 'Declaracion de privacidad',
                terms_conditions: 'Terminos y condiciones',
            },
            memberships: 'Membresías',
            membership_schedules: 'Horarios de membresía',
            membership_pools: 'Grupos de membresía',
            order_create: 'Crear una reserva',
            order_create_disallowed: 'Tu cuenta está inactiva. Póngase en contacto con MOBIAN para reactivar.',
            points_of_interest: 'Puntos de interés',
            products: 'Productos',
            product_memberships: 'Membresías de los productos',
            properties: 'Propiedades',
            propertygroups: 'Property groups',
            reservations: 'Reservaciones',
            settings: 'Ajustes',
            subcategories: 'Subcategories',
            subscriptions: 'Subscripciones',
            system_administration: 'Administración del sistema',
            users: 'Los usuarios',
            webhooks: 'Webhooks',
        },
        topbar: {
            accounts: {
                current: 'Actual',
                modal_title: 'Seleccione una cuenta',
                no_account_selected: 'Ninguna cuenta seleccionada',
            },
            security: 'Security',
            profile: 'Perfil',
            stop_impersonation: 'Detener la suplantación',
        },
    },
    notifications: {
        access_methods: {
            create: {
                success: 'El método de acceso se ha agregado correctamente',
            },
            delete: {
                success: 'El método de acceso se eliminó correctamente',
            },
            open: {
                success: 'La puerta se ha abierto',
            },
            update: {
                success: 'El método de acceso se ha actualizado correctamente',
            },
        },
        account_yields: {
            create: {
                success: 'El rendimiento del usuario se ha agregado correctamente',
            },
            delete: {
                success: 'El rendimiento del usuario se ha eliminado con éxito',
            },
            update: {
                success: 'El rendimiento del usuario ha cambiado correctamente',
            },
        },
        accounts: {
            create: {
                success: 'La cuenta se ha agregado correctamente',
                search_user_limit: 'Sólo se muestran los primeros %{count} resultados, por favor refinar aún más sus criterios de búsqueda.',
            },
            update: {
                success: 'La cuenta ha cambiado correctamente',
            },
        },
        'api-keys': {
            create: {
                success: 'El API llave se ha añadido con éxito',
            },
            delete: {
                success: 'El API llave ha eliminado con éxito',
            },
            update: {
                success: 'El API llave se ha cambiado con éxito.',
            },
        },
        bookings: {
            amend: {
                failure: 'La reserva no se ha modificado',
                success: 'La reserva se ha modificado correctamente',
            },
            refund: {
                failure: 'El reembolso no se ha realizado correctamente',
                success: 'El reembolso se ha realizado correctamente',
            },
        },
        booking: {
            cancelled: 'La reserva se canceló correctamente',
        },
        export: {
            failure: 'La exportación no se envía',
            orders: {
                failure: 'La exportación no se envía',
                success: 'La exportación se envía cuando esté listo.',
            },
            success: 'La exportación se envía cuando esté listo.',
        },
        campaigns: {
            create: {
                success: 'La campaña ha sido agregada',
            },
            update: {
                success: 'La campaña ha sido actualizada.',
            },
            remove: {
                success: 'La campaña ha sido eliminada',
            },
        },
        current_account: {
            delete: {
                success: 'Se ha eliminado al usuario de esta cuenta',
            },
        },
        discounts: {
            create: {
                success: 'El descuento se ha añadido correctamente',
            },
            delete: {
                success: 'El descuento se ha eliminado correctament',
            },
            update: {
                success: 'El descuento ha cambiado correctamente',
            },
        },
        discount_codes: {
            create: {
                success: 'El código de descuento se ha añadido correctamente',
            },
            delete: {
                success: 'El código de descuento se ha eliminado correctamente',
            },
            update: {
                success: 'El código de descuento ha cambiado correctamente',
            },
        },
        invitations: {
            created: 'La invitación se ha añadido correctamente',
            deleted: 'La invitación se ha eliminado correctamente',
            accepted: 'La invitación ha sido aceptada',
            denied: 'La invitación ha sido denegada',
        },
        item: {
            created: 'El artículo se ha añadido correctamente.',
            updated: 'El producto ha sido cambiado correctamente.',
        },
        memberships: {
            added: 'El usuario se agregó a la membresía con éxito',
            delete: {
                success: 'Se ha eliminado al usuario de la membresía',
            },
        },
        orders: {
            cancelled: {
                success: 'Order cancelled',
            },
            retry: {
                success: 'La reserva se ha vuelto a reservar',
            },
            suspicious: 'Suspicious activity on this booking',
            update: {
                success: 'La reserva ha cambiado con éxito.',
            },
        },
        points_of_interest: {
            create: {
                success: 'El POI se ha añadido con éxito',
            },
            delete: {
                success: 'El POI se ha eliminado con éxito',
            },
            images: {
                create: {
                    success: 'La imagen se ha añadido correctamente',
                },
                delete: {
                    success: 'La imagen se ha eliminado correctamente',
                },
            },
            import: {
                success: 'Los POI’s se han agregado correctamente',
            },
            update: {
                success: 'El POI ha cambiado con éxito',
            },
        },
        products: {
            create: {
                success: 'El producto ha sido agregado exitosamente',
            },
            configuration: {
                administration_fee: {
                    maximum: 'Máximo',
                    maximum_placeholder: 'p.ej. 1.99, 2.50',
                    minimum: 'Mínimo',
                    minimum_placeholder: 'p.ej. 1.99, 2.50',
                    percentage: 'Porcentaje',
                    percentage_placeholder: 'p.ej. 0.10 (10%), 0.03 (3%)',
                },
                allow_exceed_capacity_from: 'Capacidad excedida permitida no válida',
                allow_overstay: 'Exceso permitido no válido',
                arrival_dates_blocked: 'Fechas de llegada bloqueadas no válidas',
                blocked_dates: 'Fechas bloqueadas no válidas',
                capacity: 'Capacidad no válida',
                departure_dates_blocked: 'Fechas de salida bloqueadas no válidas',
                freeze_period: 'Período de congelación no válido',
                leeway_arrival: 'Margen de tiempo de llegada no válido',
                leeway_departure: 'Margen de tiempo de salida no válido',
                maximum_advance: 'Tiempo máximo anticipado no válido',
                maximum_duration: 'Tiempo mínimo anticipado no válido',
                minimum_advance: 'Tiempo mínimo anticipado no válido',
                minimum_duration: 'Duración no válida',
                number_of_persons: 'Número de personas no válido',
                operational_times: 'Horas operativas no válidas, solo permiten días de la semana específicos o no específicos',
                sales_price: 'Precio de venta no válido',
                split_percentage: 'Porcentaje de precio dividido no válido',
                terms_and_conditions: {
                    name: 'Nombre no válido',
                    link: 'URL no válida',
                },
                vat_percentage: 'Porcentaje de IVA no válido',
                voucher_include_invoice: 'Vale incluye factura no válido',
            },
            delete: {
                success: 'El producto ha sido eliminado exitosamente',
            },
            update: {
                success: 'El producto ha cambiado exitosamente',
            },
            failure: 'Product not removed.',
            images: {
                create: {
                    success: 'La imagen se ha añadido correctamente',
                },
                delete: {
                    success: 'La imagen se ha eliminado correctamente',
                },
            },
            localisation: {
                update: {
                    success: 'Los textos se han actualizado con éxito.',
                },
            },
            logo: {
                create: {
                    failure: 'Se produjo un error al cargar el logotipo.',
                    success: 'El logo esta subido',
                },
                delete: {
                    failure: 'Se produjo un error al eliminar el logotipo.',
                    success: 'El logo es eliminado',
                },
            },
            property: {
                create: {
                    success: 'La propiedad se ha añadido con éxito',
                },
                delete: {
                    success: 'La propiedad se ha eliminado con éxito',
                },
                update: {
                    success: 'La propiedad se ha cambiado con éxito',
                },
            },
            related: {
                create: {
                    success: 'El producto ha sido asignado',
                },
                delete: {
                    success: 'La relación entre los productos ha sido eliminada',
                },
            },
            resource: {
                available_resources: {
                    failure: 'Se produjo un error al obtener los recursos disponibles',
                },
                update: {
                    success: 'El recurso del producto se ha cambiado correctamente',
                },
            },
        },
        propertygroups: {
            create: {
                success: 'El grupo de propiedades se ha añadido con éxito',
            },
            delete: {
                success: 'El grupo de propiedades se ha eliminado con éxito',
            },
            update: {
                success: 'El grupo de propiedades ha sido cambiado con éxito',
            },
        },
        properties: {
            create: {
                success: 'Las propiedades se han añadido con éxito',
            },
            delete: {
                success: 'Las propiedades son eliminadas con éxito',
            },
            update: {
                success: 'Las propiedades se han cambiado con éxito',
            },
        },
        profile: {
            update: {
                success: 'El perfil se ha cambiado correctamente.',
            },
        },
        subcategories: {
            create: {
                success: 'La subcategoría se ha añadido con éxito',
            },
            delete: {
                success: 'La subcategoría se ha eliminado con éxito',
            },
            update: {
                success: 'La subcategoría se ha cambiado con éxito',
            },
        },
        subscriptions: {
            create: {
                success: 'La suscripción se ha añadido con éxito',
            },
            delete: {
                success: 'La suscripción se ha eliminado con éxito',
            },
            update: {
                success: 'La suscripción se ha cambiado con éxito',
            },
            confirm: {
                success: 'La suscripción ha sido confirmada con éxito',
            },
            terminate: {
                success: 'La suscripción ha sido terminada con éxito',
            },
        },
        subscriptionProducts: {
            create: {
                success: 'El producto de suscripción se ha agregado con éxito.',
            },
            delete: {
                success: 'El producto de suscripción se ha eliminado con éxito.',
            },
        },
        users: {
            create: {
                success: 'El usuario ha sido agregado exitosamente',
            },
            delete: {
                success: 'El usuario ha sido eliminado exitosamente',
            },
            update: {
                success: 'El usuario ha cambiado exitosamente',
            },
            confirmed: {
                success: 'El usuario ha sido confirmado con éxito.',
            },
            password: {
                failure: 'Algo salió mal al enviar la solicitud. Intenta nuevamente más tarde.',
                success: 'El usuario será informado por correo electrónico con una solicitud de restablecimiento de contraseña.',
            },
        },
        user_product_membership: {
            create: {
                success: 'La membresía de producto del usuario ha sido añadida',
            },
            delete: {
                success: 'La membresía de producto del usuario ha sido eliminada',
            },
            update: {
                success: 'La membresía de producto del usuario ha sido actualizada',
            },
        },
        utilities: {
            translate: {
                create: {
                    success: 'El texto base ha sido traducido.',
                },
            },
        },
        yields: {
            delete: {
                success: 'El rendimiento se elimina con éxito.',
            },
        },
        webhooks: {
            create: {
                success: 'El webhook ha sido añadido con éxito.',
            },
            delete: {
                success: 'El webhook ha sido eliminado con éxito',
            },
            update: {
                success: 'El webhook ha sido actualizado exitosamente.',
            },
        },
    },
    pages: {
        booking_tool: {
            not_available: {
                text: 'Parece que no hay embudo salpicadero disponible para esta cuenta. Para obtener más información, póngase en contacto con su administrador de cuentas.',
                title: 'Oh no... :(',
            },
        },
        create_booking: {
            description: 'Antes de que pueda ver los productos, le pedimos que complete estos campos para que la búsqueda sea más específica.',
            form: {
                errors: {
                    destination_arrival_date: 'Por favor complete una fecha',
                    destination_arrival_time: 'Por favor complete un tiempo',
                    destination_departure_date: 'Por favor complete una fecha',
                    destination_departure_time: 'Por favor complete un tiempo',
                    destination_google_place_id: 'Por favor complete un destino',
                    number_of_persons: 'Por favor llene la cantidad de personas',
                    one_way: 'Por favor, rellene el tipo de viaje',
                    origin_google_place_id: 'Por favor, rellene la dirección para ser recogido',
                },
                fields: {
                    destination_arrival_date: '¿Cuando te quieres ir?',
                    destination_arrival_time: 'Hora de salida',
                    destination_departure_date: '¿Cuándo quieres volver?',
                    destination_departure_time: 'Tiempo de vuelta',
                    destination_google_place_id: '¿Cual es tu destino?',
                    one_way: {
                        retour_trip: 'retour de viaje',
                        single_trip: 'Viaje individual',
                    },
                    origin_google_place_id: 'Mi dirección',
                    service: {
                        park_and_sleep: 'Aparcar y dormir',
                        park_and_walk: 'Aparcar y caminar',
                        public_transport: 'Transporte público',
                        short_long_parking: 'Parking corta y larga estancia',
                        taxi: 'Taxi',
                        title: 'Opciones de servicio',
                        valet_parking: 'Servicio de parcacoches',
                    },
                },
            },
            not_available: {
                text: 'Parece que no hay embudo salpicadero disponible para esta cuenta. Para obtener más información, póngase en contacto con su administrador de cuentas.',
                title: 'Oh no... :(',
            },
            title: 'Crear una reserva',
        },
        dashboard: {
            select: 'Selecciona tu moneda',
            widgets: {
                statistics_card: {
                    bookings: 'Reservas',
                    current_week: 'Esta semana',
                    last_week: 'La semana pasada',
                    today: 'Hoy',
                    week: 'Semana',
                    yesterday: 'Ayer',
                },
                statistics_graph: {
                    current_month: 'últimas 4 semanas',
                    previous_year: 'el año pasado',
                    title: 'Reservas',
                },
            },
        },
    },
    resources: {
        access_methods: {
            create: {
                title: 'Crea un método de acceso',
            },
            delete: {
                title: 'Eliminar método de acceso',
                description: '¿Está seguro de que desea eliminar este método de acceso?',
            },
            edit: {
                title: 'Edite este método de acceso',
            },
            fields: {
                access_id: 'ID de acceso',
                access_point_access_method_id: 'ID del método de acceso del punto de acceso',
                access_point_id: 'ID del punto de acceso',
                carpark_id: 'ID de aparcamiento',
                connector_id: 'ID de conector',
                custom_counter_id: 'ID de contador personalizado',
                depot_id: 'ID de depósito',
                direction: 'Dirección',
                door_id: 'ID de la puerta',
                enabled: 'Estado',
                gate_id: 'ID de puerta',
                location_id: 'ID de ubicación',
                is_allowed_for_users: 'Permitir a los usuarios',
                name: 'Nombre',
                phone: 'Número de teléfono',
                phone_country: 'País del número de teléfono',
                product_id: 'Identificación de producto',
                station_id: 'ID de estación',
                subscription_id: 'ID de suscripción',
            },
            list: {
                active: 'Activo',
                direction: 'Dirección',
                directions: {
                    1: 'Entrada / Salida',
                    2: 'Entrar',
                    3: 'Salida',
                },
                enabled: 'Estado',
                inactive: 'Inactivo',
            },
            no_results: 'No se encontraron métodos de acceso',
            open: 'Puerta abierta',
            requesting: 'Solicitando',
            title: 'Métodos de acceso',
        },
        access_points: {
            actions: {
                create: {
                    title: 'Crear un punto de acceso',
                },
                edit: {
                    title: 'Edite este punto de acceso: %{title}',
                },
            },
            fields: {
                access_point: 'Elija un punto de acceso',
                access_method: 'Elija un método de acceso',
                product: 'Producto',
                title: 'Título',
                type: 'Tipo',
            },
            no_results: 'No se encontraron un punto de acceso',
            title: 'Puntos de acceso',
            types: {
                access: 'Acceso',
                on_site: 'Al sitio',
            },
        },
        account_yields: {
            actions: {
                create: 'Crea un rendimiento de usuario',
                edit: 'Actualizar el rendimiento del usuario',
            },
            fields: {
                accountId: 'Usuario',
                yield: 'Yield',
            },
            title: 'Yields',
        },
        accounts: {
            actions: {
                activate: 'Activar',
                create: 'Crear una cuenta',
                deactivate: 'Desactivar',
                edit: 'Editar cuenta',
            },
            activity: {
                activate: {
                    title: 'La cuenta se activará',
                    description: 'Cuando la cuenta está activo, la cuenta puede iniciar sesión en nuestros paneles, aplicaciones y usar nuestros servicios.',
                },
                deactivate: {
                    title: 'La cuenta será desactivado',
                    description: 'Cuando la cuenta está inactivo, la cuenta ya no puede iniciar sesión en nuestros paneles, aplicaciones o usar nuestros servicios.',
                },
            },
            fields: {
                address: 'Habla a',
                bic: 'BIC',
                city: 'Ciudad',
                contact_details: 'Detalles de contacto',
                contact_email: 'Correo electrónico',
                contact_emergency_phone: 'Teléfono de emergencia',
                contact_phone: 'Teléfono de contacto',
                contact_whatsapp: 'Número de whatsapp',
                country: 'País',
                email: 'Email',
                iban: 'IBAN',
                is_enabled: 'Activo',
                last_name: 'Apellido',
                locale: 'Local',
                name: 'Nombre',
                notify_on_cancelled: 'Notificar en cancelado',
                notify_on_created: 'Notificar al crearse',
                notify_on_modified: 'Notificar al modificar',
                orders: 'Pedidos',
                owner: 'Propietario',
                phone: 'Teléfono',
                registration: 'Número COC',
                role: 'Papel',
                vat: 'IVA',
                zipcode: 'Código postal',
            },
            filters: {
                active: {
                    active: 'Solo activo',
                    inactive: 'Solo inactivo',
                },
            },
            forms: {
                account: 'Cuenta',
                account_search_user: 'Buscar usuario',
                account_select_user: 'Seleccionar usuario',
                address: 'Habla a',
                company: 'Empresa',
                contact: 'Contacto',
                general: 'General',
                notifications: 'Preferencias de notificación por correo',
                products: 'Últimos productos actualizados',
                registrations: 'Inscripciones',
            },
            name: 'Usuario',
            notifications: {
                inactive: 'Este usuario está inactivo. Haga clic en el botón Activar para reactivar el usuario.',
                not_confirmed: 'Este usuario aún no ha confirmado su cuenta.',
            },
            products: {
                actions: {
                    list: 'Mostrar todos los productos (%{total})',
                },
            },
            reset_password: {
                description: 'Restablecer una contraseña enviará una nueva contraseña al correo electrónico del usuario. La contraseña antigua ya no será utilizable. Las sesiones actualmente iniciadas de este usuario requerirán que inicie sesión en todos los dispositivos con su nueva contraseña.',
                title: 'Restablecer la contraseña del usuario',
            },
            roles: {
                administrator: 'Administrador',
                provider: 'Proveedor',
                reseller: 'Revendedores',
            },
            select_user: {
                table: {
                    email: 'Email',
                    name: 'Nombre',
                },
            },
            title: 'Usuarios',
        },
        'api-keys': {
            actions: {
                create: 'Crear una API key',
                edit: 'Editar clave API',
            },
            error: {
                description: 'Se alcanzó la cantidad máxima de claves API disponibles. No puede crear más claves API. Elimine uno antes de crear uno nuevo.',
                title: 'Ups ...',
            },
            fields: {
                created_at: 'Date',
                last_used_at: 'Utilizado por última vez',
                name: 'Name',
                token: 'Llave',
            },
            modal: {
                description: 'Aquí está su nueva API key. <strong>Esta es la única vez que se mostrará el token, ¡así que asegúrese de no perderlo!</strong> Puedes eliminar el token en cualquier momento.',
                title: 'API key para %{name}',
            },
            title: 'API keys',
        },
        bookings: {
            actions: {
                edit: 'Reserva: %{name} (%{id})',
            },
            amend: {
                buttons: {
                    paymentInvoice: 'Pagar mediante factura',
                    paymentMethod: 'Seleccionar método de pago',
                    price: 'Nuevo precio',
                },
                loading: {
                    'price-check-error': 'Algo salió mal al comprobar un nuevo precio',
                    'payment-invoice': 'Intento de pago mediante factura',
                    'payment-link': 'Creando enlace de pago',
                    'payment-not-required': 'Modificar los valores actualizados',
                    form: 'Obteniendo nuevos precios',
                    payments: 'Obteniendo todos los métodos de pago',
                    transactions: 'Creando una transacción',
                },
                messages: {
                    'amendError': 'Algo salió mal al guardar el formulario.',
                    'payment-invoice': 'El pago es facturable. Puede guardar el formulario.',
                    'payment-not-required': 'No se requiere pago. Puede guardar el formulario.',
                    'payment-required': 'La diferencia de precio no incluye los costos de transacción potenciales.',
                    'price-check-error': 'Algo salió mal al comprobar un nuevo precio',
                    availability: 'Este producto ya no esta disponible.',
                    linkCopied: 'Se copia el enlace de pago',
                },
                prices: {
                    current: 'Precio actual',
                    difference: 'Diferencia',
                    new: 'Nuevo precio',
                },
                phase: {
                    paymentLink: 'Su enlace de pago para %{title} - %{method}',
                },
                title: 'Modificar la reserva',
            },
            fields: {
                createdAt: 'Creado en',
                customerRemarks: 'Comentarios del cliente',
                destinationArrivalDate: 'Fecha de llegada',
                email: 'Correo electrónico',
                firstName: 'Nombre de pila',
                fullName: 'Nombre completo',
                funnelId: 'Campaña',
                lastName: 'Apellido',
                licensePlate: 'Placa',
                locale: 'Local',
                orderId: 'Solicitar ID',
                phone: 'Teléfono',
                price: 'Precio',
                product: 'Producto',
                resellerId: 'Revendedores',
                status: 'Estado',
            },
            forms: {
                additional: 'Adicional',
                general: 'General',
            },
            refund: 'Reembolso de reservacion',
            title: 'Reservaciones',
        },
        campaigns: {
            actions: {
                create: 'Crea una campaña',
                edit: 'Actualiza esta campaña: %{title}',
            },
            fields: {
                accountId: 'Revendedor',
                id: 'ID',
                identifier: 'Identificador',
                name: 'Nombre',
            },
            name: 'Campaña',
            title: 'Campañas',
            show: {
                api: 'API',
                catalogue: 'Catálogo',
                week: 'Semana',
                last_week: 'Reservas en las últimas semanas',
                week_number: '# de la semana',
                bookings_amount: '# de reservas',
                tabs_title: 'Información sobre el uso del catálogo / API',
                catalogue_p1: '¿No está listo para una integración completa de API pero desea comenzar de forma rápida y segura? El embudo de reserva de MOBIAN se puede usar fácilmente y funciona inmediatamente después de crear una campaña. Lo único que necesitamos que envíe en su enlace es su identificador de campaña. Su identificador es un token único que nos facilita agregar la reserva a su cuenta como si la hubiera vendido a través de su propio sitio web. Hemos agregado un ejemplo a continuación:',
                catalogue_p2: 'Puede agregar el identificador de campaña a cualquier página que el embudo de reserva tenga para ofrecer. De esa manera, siempre puede permitir que su usuario comience en cualquier parte del embudo y adapte la experiencia a sus necesidades.',
                catalogue_p3: 'Tan pronto como un usuario llega a la página a la que se adjunta su campaña, recibe un marcador. Este marcador se asegura de que cada venta que realice esta persona mientras la tenga estará bajo su cuenta. Se consciente; en caso de que un usuario visite el embudo de reserva con una nueva campaña, esto anulará el marcador activo actual. Los marcadores tienen un tiempo de reutilización de 72 horas después del cual se desactivará. Las reservas realizadas después de ese período no se adjuntarán a su cuenta hasta que vuelvan a visitar un enlace con su identificador.',
                api_p1: '¡Agradable! Se está integrando con la API pero desea definir diferentes campañas o embudos a través de los cuales está vendiendo. Puede adjuntar fácilmente una reserva a la campaña. Para esto, es posible que necesite que su personal técnico ajuste algo en las solicitudes que envíe a nuestra API. Al crear una reserva, ya está comunicando mucha información y estamos agregando otra pieza al rompecabezas. En la documentación encontrará un parámetro llamado funnel_id. Para la información de esta pieza, debe tener una identificación que pueda ingresar.',
                api_p2: 'El identificador para esta campaña es:',
                api_p3: 'Después de crear las reservas con este ID, se adjuntarán a esta campaña automáticamente.',
            },
        },
        bookingStats: {
            fields: {
                AUD: 'AUD',
                CHF: 'CHF',
                EUR: 'EUR',
                GBP: 'GBP',
                NZD: 'NZD',
                SEK: 'SEK',
                USD: 'USD',
                amount: 'Cantidad',
                bookings: 'Reservas',
                label: 'Fecha',
                total: 'Total',
            },
            name: 'Estadística',
            title: 'Estadísticas de reserva',
        },
        discount_codes: {
            actions: {
                create: 'Crea un código de descuento',
                edit: 'Editar código de descuento: %{title}',
            },
            components: {
                expiry_date: {
                    placeholder: 'Fecha de expiración',
                },
                status: {
                    choices: {
                        unused: 'Sin usar',
                        used: 'Usado',
                    },
                },
                type: {
                    choices: {
                        multi: 'Multi uso',
                        single: 'Único uso',
                        wallet: 'Billetera',
                    },
                },
            },
            fields: {
                amount: 'Monto',
                amount_used: 'Monto Usado',
                currency: 'Moneda',
                expiry_date: 'Fecha de expiración',
                id: 'ID',
                is_enabled: 'Activo',
                last_used_at: 'Último uso en',
                percentage: 'Porcentaje',
                status: 'Estado',
                token: 'Token',
                type: 'Tipo',
            },
            title: 'Códigos de descuento',
        },
        discounts: {
            actions: {
                activate: 'Activar',
                create: 'Crea un descuento',
                deactivate: 'Deactivar',
                edit: 'Editar descuento: %{title}',
                list: 'Listar',
            },
            activity: {
                activate: {
                    title: 'Activate',
                    description: 'Seguro que quieres activar este descuento?',
                },
                deactivate: {
                    title: 'Deactivar',
                    description: 'Seguro que quieres desactivar este descuento?',
                },
            },
            fields: {
                accountId: 'Cuenta',
                amount: 'Monto',
                apply_on_fees: 'Aplicar a las tarifas',
                created_at: 'Creado en',
                currency: 'Moneda',
                end_processing: 'Terminar proceso',
                expiry_date: 'Fecha de expiración',
                id: 'ID',
                is_enabled: 'Activo',
                limit: 'Límite',
                percentage: 'Porcentaje',
                priority: 'Prioridad',
                title: 'Título',
                uses_discount_codes: 'Usa código de descuento',
            },
            forms: {
                account: 'Cuenta',
                discount_codes: 'Códigos de descuento',
                general: 'General',
                manage_discount_codes: 'Códigos de descuento',
            },
            operators: {
                labels: {
                    and: 'Y',
                    equal_or_greater_than: 'Igual o mayor que',
                    equal_or_less_than: 'Igual o inferior a',
                    equal: 'Es igual',
                    greater_than: 'Mayor que',
                    less_than: 'Menos de',
                    not_equal: 'No es igual a',
                    or: 'O',
                    within: 'Dentro',
                },
                title: 'Operador',
            },
            placeholders: {
                email_domain: 'p. ej. nu.nl',
            },
            rules: {
                appliance: 'Reglas de aplicación',
                condition: 'Reglas de condición',
                title: 'Reglas de aplicación y condiciones',
                no_results: 'No hay reglas de %{type}',
            },
            types: {
                global: 'Global',
                regular: 'Regulares',
            },
            title: 'Descuentos',
        },
        invitations: {
            actions: {
                accept: {
                    title: 'Aceptar invitación',
                    description: '¿Quieres aceptar esta invitación?',
                },
                deny: {
                    title: 'Denegar invitación',
                    description: '¿Quieres negar esta invitación?',
                },
            },
            no_invitations: 'No se encontraron invitaciones.',
            open_invitations: 'Invitaciones abiertas',
            request_title: 'Solicitudes de invitaciones',
            sent_title: 'Invitaciones enviadas',
            title: 'Invitaciones',
        },
        invoices: {
            download: 'Descargar factura',
            export: {
                success: 'Las facturas se ha exportaron con exito.',
                title: 'Exportar facturas',
                lines: {
                    title: 'Exportar líneas de factura',
                },
            },
            fields: {
                amount: 'Monto',
                invoiced_at: 'Facturado en',
                status: 'Estado',
            },
            show: {
                details: 'Detalles',
                title: 'Mostrar factura',
            },
            status: {
                charged_back: 'Devolución',
                open: 'Abierta',
                overdue: 'Vencida',
                paid: 'Pagada',
                paid_manually: 'Pagado manualmente',
                processing: 'Processing',
            },
            title: 'Facturas',
        },
        general: {
            fields: {
                boolean: {
                    yes: 'Sí',
                    no: 'No',
                },
            },
        },
        memberships: {
            actions: {
                edit: 'Editar membresía: %{title}',
            },
            fields: {
                concurrency: 'Concurrencia',
                purge_reservations: 'Depurar reservas',
                paid_by_invoice: 'Pagado por factura',
            },
            messages: {
                created: {
                    success: 'La membresía se creó correctamente',
                },
                deleted: {
                    success: 'La membresía se eliminó correctamente',
                },
                updated: {
                    success: 'La membresía se ha actualizado',
                },
            },
        },
        membership_schedules: {
            messages: {
                created: {
                    success: 'Horario de membresía creado con éxito',
                },
                deleted: {
                    success: 'Horario de membresía eliminado con éxito',
                },
                updated: {
                    success: 'Horario de membresía actualizado con éxito',
                },
            },
        },
        no_account: {
            description: 'Para poder utilizar el panel de control, debe estar asociado a un socio. Es posible que uno de nuestros socios ya te haya enviado una invitación para unirte a la cuenta de su empresa. Haz clic en el botón de arriba para ver si tienes invitaciones abiertas.',
            title: 'No hay cuentas disponibles',
        },
        orders: {
            actions: {
                check_new_price: 'Consultar el nuevo precio',
                csv: 'CSV',
                export: 'Exportar reservas',
                export_related: 'Exportar Reservas de reservas',
                order_email_resent: 'Order email resent',
                resend_email: 'Reenviar email',
                retry: 'Rever',
            },
            amend: {
                message: {
                    availability: 'Este producto ya no esta disponible.',
                    payment: {
                        required: 'La diferencia de precio no incluye los costos de transacción potenciales.',
                    },
                },
                payment_method: {
                    button: 'Método de Pago',
                },
                payment_link: {
                    title: 'Su enlace de pago para %{title}:',
                },
                price: {
                    current: 'Precio anterior',
                    new: 'Nuevo precio',
                    difference: 'Diferencia',
                },
                title: 'Modificar la reserva',
            },
            cancel: {
                description: '¿Estás seguro de que deseas cancelar esta reserva?',
                title: 'Cancelar Reserva',
            },
            edit: {
                no_longer_editable: 'Esta información ya no se puede editar en el sistema, comuníquese directamente con el proveedor.',
            },
            fields: {
                cancelled_at: 'Cancelado en',
                commission: {
                    int_yield_price: 'Servicio de revendedor de rendimiento',
                    mobian_commission_total: 'Total',
                    mobian_product_commission_price: 'MOBIAN comisión',
                    mobian_product_yield_commission_price: 'Comisión de rendimiento del producto',
                    mobian_vat_amount: 'Comisión IVA',
                    mobian_vat_price: 'Total',
                    price_administration_fee: 'Costos de administración',
                    price_base: 'Precio base',
                    price_costfree_cancellation: 'Cancelación Gratuita',
                    price_options: 'Opciones',
                    provider_total_price: 'Total parcial',
                    reseller_commission_total: 'Comisión de revendedor',
                    reseller_product_commission_price: 'Comisión de producto',
                    reseller_product_price: 'Total de reserva',
                    reseller_product_yield_commission_price: 'Comisión de rendimiento',
                    reseller_vat_amount: 'IVA',
                    reseller_vat_price: 'Total',
                },
                country_code: 'Código de país',
                created_at: 'Creado en',
                customer_remarks: 'Comentarios del cliente',
                destination_address: 'A',
                destination_arrival_date: {
                    hours: 'horas',
                    label: 'Fecha de llegada',
                    minutes: 'minutos',
                },
                destination_departure_date: {
                    hours: 'horas',
                    label: 'Fecha de salida',
                    minutes: 'minutos',
                },
                drop_off_date: 'Fecha de inicio',
                ending_at: 'Terminando en',
                email: 'Email',
                first_name: 'Nombre de pila',
                flight_number: 'Número de vuelo',
                full_name: 'Nombre',
                campaigns: 'Campañas',
                is_test: 'Prueba',
                last_name: 'Apellido',
                license_plate: 'Placa',
                locale: 'Idioma',
                location_address: 'Ubicación',
                number_of_persons: 'Número de personas',
                order_id: 'Reserva',
                origin_address: 'Desde',
                payment_amount_paid: 'Cantidad pagada',
                payment_status: 'Estado de pago',
                phone: 'Número de teléfono',
                pick_up_date: 'Fecha de recogida',
                price: 'Precio',
                product: 'Producto',
                provider: 'Proveedor',
                reservation_status: 'Estado de reserva',
                return_flight_number: 'Número de vuelo de regreso',
                starting_at: 'A partir de',
                status: 'Estado',
                updated_at: 'Última actualización',
            },
            filters: {
                cancelled_at: {
                    label: 'Cancelado en',
                    placeholder: 'Cancelado en',
                },
                created_at: {
                    label: 'Creado en',
                    placeholder: 'Creado en',
                },
                currencies: {
                    label: 'Monedas',
                },
                destination_address: {
                    label: 'Punto de entrega',
                },
                destination_arrival_date: {
                    label: 'Fecha de llegada',
                    placeholder: 'Inicio (llegada al destino)',
                },
                destination_departure_date: {
                    label: 'Fecha de salida',
                    placeholder: 'Fin (salida del destino)',
                },
                interval: {
                    choices: {
                        day: 'día',
                        month: 'mes',
                        week: 'semana',
                        year: 'año',
                    },
                    label: 'Intervalo',
                },
                is_test_order: {
                    choices: {
                        only_real: 'Real',
                        only_test: 'Prueba',
                    },
                    label: 'Reservas',
                },
                last_name: 'Apellido',
                payment_status: {
                    choices: {
                        chargedback: 'Cargado de vuelta',
                        deferred: 'Diferido',
                        failed: 'Ha fallado',
                        in_progress: 'En progreso',
                        refunded: 'Reintegrado',
                        success: 'Exitoso',
                        unknown: 'Desconocido',
                    },
                    label: 'Estado de pago',
                },
                origin_address: {
                    label: 'Lugar de recogida',
                },
                reservation_status: {
                    choices: {
                        canceled: 'Cancelado',
                        completed: 'Terminado',
                        error: 'Error',
                        pending: 'Pendiente',
                        split: 'Dividir',
                        under_review: 'Bajo revisión',
                    },
                    label: 'Estado de reserva',
                },
            },
            information: {
                consumer_communication: 'Este cliente no recibe automáticamente correos electrónicos de reserva.',
                multibookings: {
                    split_from: 'Esta reserva pertenece a una multireserva',
                    split_to: 'Esta reserva ha sido dividida para',
                },
                test_booking: 'Esta reserva se crea como una orden de prueba.',
            },
            name: 'Reservas',
            paymentSlip: {
                download: {
                    title: 'Descargar comprobante de pago',
                },
                send: {
                    description: 'El consumidor recibe un comprobante de pago que contiene todas las actualizaciones, ¿está seguro de que desea enviar el comprobante de pago manualmente?',
                    success: 'El recibo de pago se envió correctamente',
                    title: 'Enviar Comprobante de Pago',
                },
                title: 'Comprobante de Pago',
            },
            receipt: {
                administration_costs: 'Costes administrativos',
                administration_fees: 'Gastos administrativos',
                base_price: 'Precio base',
                costfree_cancellation: 'Cancelación gratuita',
                membership_deduction: 'Deducción de membresía',
                options: 'Opciones',
                service_yield: 'Rendimiento del servicio',
                split_deduction: 'Deducción dividida',
                subtotal_additional: 'Subtotal costos adicionales',
                subtotal_base: 'Subtotal',
                subtotal_discounts: 'Subtotal descuentos',
                total: 'Total',
                transaction_fees: 'Costos de transacción',
            },
            retry: {
                description: 'Are you sure you wish to retry this booking?',
                title: 'Retry Booking',
            },
            show: {
                activities: {
                    booking: {
                        empty: 'No hay actividades registradas para esta reserva.',
                        label: 'Ocupaciones',
                        table: {
                            activity: 'Actividad',
                            actor: 'Usuario',
                            created_at: 'Fecha',
                            property: 'Valor',
                            status: 'Estado',
                            target_id: 'Identificador',
                            target_type: 'Objetivo',
                        },
                    },
                },
                booking_information: 'Información de la reserva',
                paid_on_invoice: 'Esta reserva se paga en la factura.',
                product: 'Producto',
                reseller: 'Revendedores',
                reservation: 'Reserva',
                reservation_details: 'Detalles de la reserva',
                travel_details: 'Detalles de viaje',
            },
            tabs: {
                activities: 'Ocupaciones',
                commission: 'Comisión',
                customer: 'Cliente',
                payment: 'Pago',
                travel: 'Viajar',
            },
            voucher: {
                download: {
                    title: 'Descargar vale',
                },
                send: {
                    description: 'El documento está publicado en un cupón para la actualización, pero no hemos recibido ningún cupón. ¿Qué vale la pena?',
                    success: 'El vale se envió con éxito!',
                    title: 'Enviar vale',
                },
                after_alteration: {
                    description: '¿Quieres notificar al cliente sobre las actualizaciones?',
                },
                title: 'Vale',
            },
        },
        password: {
            error: {
                password_current: 'La contraseña no coincide con la contraseña existente.',
            },
            name: 'Cambia tu contraseña',
            fields: {
                password_current: 'Current Password',
                password_new: 'contraseña actual',
                password_confirmation: 'Nueva confirmación de contraseña',
            },
            success: 'La contraseña se ha guardado correctamente.',
        },
        points_of_interest: {
            actions: {
                create: 'Crear un nuevo punto de interés',
                edit: 'Editar punto de interés: %{title}',
                show: 'Punto de interés: %{title}',
            },
            fields: {
                address: 'Dirección',
                city: 'Ciudad',
                country: 'País',
                google_place_id: 'Google Place ID',
                id: 'ID',
                is_highlighted: 'Destacado',
                latitude: 'Latitud',
                location_x: 'Ubicación x',
                location_y: 'Ubicación y',
                longitude: 'Longitud',
                name: 'Nombre',
                state: 'Estado',
                street: 'Calle',
                street_number: 'Nº',
                type: 'Tipo de PDI',
                zipcode: 'Código postal',
            },
            import: {
                dropzone: {
                    description: 'Arrastra y suelta o presiona para importar tu archivo CSV con los nuevos puntos de interés',
                    title: 'Cargue un CSV',
                },
                title: 'Importar puntos de interés desde un archivo CSV',
            },
            promoted_products: {
                add: 'Agregar productos promocionados',
                no_results: 'No se encontraron productos promocionados',
                title: 'Productos promocionados',
            },
            title: 'Puntos de interés',
            types: {
                accommodation: 'Alojamiento',
                airport: 'Aeropuerto',
                beach: 'Playa',
                bridge: 'Puente',
                business_centre: 'Centro de negocios',
                city: 'Ciudad',
                cultural: 'Cultural',
                education: 'Educación',
                event: 'Evento',
                event_center: 'Centro de eventos',
                government_building: 'Edificio del gobierno',
                hospital: 'Hospital',
                library: 'Biblioteca',
                museum: 'Museo',
                neighbourhood: 'Barrio',
                other: 'Otro',
                park: 'Parque',
                port: 'Puerto',
                recreation: 'Recreación',
                religious_building: 'Edificio religioso',
                restaurant: 'Restaurante',
                shopping_centre: 'Centro comercial',
                sight: 'Punto de interés',
                station: 'Estación de ferrocarril',
            },
        },
        products: {
            actions: {
                activate: 'Activar',
                create: 'Crear producto',
                deactivate: 'Desactivar',
                edit: 'Editar producto',
                localisation: 'Contenido del producto',
                occupancy: 'Ocupación',
                resource: 'Recurso',
            },
            activity: {
                activate: {
                    title: 'El producto está activado.',
                    description: 'El producto ahora se hace visible en todas nuestras plataformas.',
                },
                deactivate: {
                    title: 'El producto está desactivado.',
                    description: 'El producto no es visible y el usuario final ya no lo verá.',
                },
            },
            administration_fee: {
                title: 'Tarifa de administración',
            },
            advancedTimes: {
                title: 'Tiempos avanzados máximos y mínimos',
                fields: {
                    maximum_advance: 'Tiempo máximo de avance',
                    minimum_advance: 'Tiempo mínimo de avance',
                },
            },
            allowed_capacity_excess: {
                title: 'Exceso de capacidad permitido',
                fields: {
                    capacity_excess: 'Exceso de capacidad',
                },
            },
            attribute: 'Atributo',
            availability: {
                button: 'Validar',
                dialog: {
                    description: '',
                    title: 'Validar el producto',
                },
                results: {
                    arrival_dates_blocked: 'Fechas de llegada bloqueadas',
                    available_price_information: 'Precio disponible',
                    blocked_dates: 'Fechas bloqueadas',
                    capacity: 'Capacidad',
                    configuration: 'Configuración del producto',
                    consumer_price: 'Precio al consumidor',
                    departure_dates_blocked: 'Fechas de salida bloqueadas',
                    has_time_zone: 'Zona horaria correcta',
                    is_visible: 'Producto está visible',
                    maximum_advance: 'Max. Avance',
                    maximum_duration: 'Max. Duración',
                    minimum_advance: 'Mín. Avance',
                    minimum_duration: 'Mín. Duración',
                    operational_times: 'Tiempos operativos',
                    pricing_service_price: 'Precio del servicio de precios',
                    product_enabled: 'Producto activo',
                    provider_enabled: 'Proveedor activo',
                    provider_price: 'Precio del proveedor',
                    supported_currency: 'Moneda soportada',
                    supported_resource: 'Configuración de recursos correcta',
                    valid_price: 'Precio valido',
                },
            },
            arrival_dates_blocked: {
                title: 'Llegada bloqueada',
                add: 'Añadir Llegada Bloqueada',
                no_result: 'No se encontraron fechas de llegada bloqueadas.',
            },
            blocked_dates: {
                title: 'Fechas bloqueadas',
                add: 'Agregar Fecha bloqueada',
                no_result: 'No se encontraron fechas bloqueadas',
            },
            capacity: {
                title: 'Capacidad',
            },
            configuration: {
                saved: 'La configuración del producto fue guardada exitosamente.',
            },
            count: 'Conteo',
            departure_dates_blocked: {
                title: 'Fechas de salida bloqueadas',
                add: 'Agregar fechas bloqueadas',
                no_result: 'No se encontraron fechas de salida bloqueadas',
            },
            duration: {
                no_duration: 'No se ha encontrado una duración máxima o mínima para este producto.',
                fields: {
                    maximum_duration: 'Duración máxima',
                    minimum_duration: 'Duración mínima',
                },
                placeholders: {
                    duration: 'ej. 10d o 12h',
                    duration_day: 'ej. 10d',
                    duration_hour: 'ej. 12h',
                },
                response: {
                    save: 'Los tiempos de duración se han guardado correctamente',
                },
            },
            edit: {
                location: 'Editar ubicación',
                resource: 'Editar recurso',
            },
            fields: {
                active: 'Activo',
                administration_fee: {
                    maximum: 'Máximo',
                    maximum_placeholder: 'p.ej. 1.99, 2.50',
                    minimum: 'Mínimo',
                    minimum_placeholder: 'p.ej. 1.99, 2.50',
                    percentage: 'Porcentaje',
                    percentage_placeholder: 'p.ej. 0.10 (10%), 0.03 (3%)',
                },
                allow_overstay: 'Permitir exceso',
                category_id: 'Categoría',
                city: 'Ciudad',
                communicate_email_addresses: 'Comunicar direcciones de correo electrónico',
                company_id: 'Proveedor',
                conditionz: 'Términos y condiciones',
                configuration: 'Configuración',
                country_code: 'Código de la tierra',
                country: 'País',
                date: 'Fecha',
                description_de: 'Descripción en alemana',
                description_en: 'Descripción en ingles',
                description_es: 'Descripción en español',
                description_fr: 'Descripción en francés',
                description_it: 'Descripción en italiano',
                description: 'Descripción en holandesa',
                duration: 'Duración máxima y mínima',
                email_domain: 'Dominio del email',
                email_from: 'Email desde',
                email1: 'Email proveedor',
                email2: 'Email admin',
                enabled: 'Activo',
                freeze_period: 'Período de congelación',
                from: 'Desde',
                icon: 'Icon',
                id: 'ID',
                inactive: 'Inactivo',
                internal_qr_code: 'Código QR interno',
                is_combined: 'Producto combinado',
                is_official_facility: 'Esta es una facilidad oficial.',
                is_visible: 'Visible',
                key: 'Clave',
                leeway: 'Margen de llegada y salida',
                location_address: 'Dirección',
                location_id: 'ID de ubicación',
                location_latitude: 'Latitud',
                location_longitude: 'Longitud',
                logo: 'Logo',
                mail_de: 'Email escrito en aleman',
                mail_en: 'Email escrito en ingles',
                mail_fr: 'Email escrito en francés',
                mail: 'Email escrito en Holandés',
                map_image: 'Imagen de ubicación',
                number_of_persons: 'Número de personas',
                operational_times: 'Horas operativas',
                options: 'Opciones',
                parking_id: 'ID Aparcamiento',
                phone: 'Número de teléfono',
                point_of_interest_id: 'Point of interest',
                product_id: 'Proveedor',
                property_id: 'Propiedad',
                provider_id: 'Proveedor',
                radius: 'Radio',
                rating: 'Clasificación',
                resource: {
                    id: 'ID de recurso',
                    name: 'Nombre del recurso',
                },
                service_id: 'Servicio',
                split_percentage: 'Porcentaje de precio dividido',
                street: 'Calle',
                subcategory_id: 'Subcategoría',
                terms_and_conditions: {
                    title: 'Términos y condiciones',
                    link: 'URL',
                    link_placeholder: 'Introduce la URL',
                    name: 'Nombre',
                    name_placeholder: 'Introduce el nombre',
                },
                title: 'Título',
                to: 'Hasta',
                type: 'Tipo',
                updated_at: 'Actualizado en',
                value: 'Valor',
                vat_percentage: 'Porcentaje de IVA',
                voucher_include_invoice: 'Vale incluye factura',
                weekday: 'Día',
                zipcode: 'Código postal',
            },
            filters: {
                radius: {
                    '5': '5km',
                    '10': '10km',
                    '15': '15km',
                    '20': '20km',
                    '25': '25km',
                },
            },
            forms: {
                access_methods: 'Métodos de acceso',
                content: 'Contenido',
                general: 'General',
                location: 'Ubicación',
                logo: 'Logo',
                preferences: 'Preferencias',
                properties: 'Propiedades',
                provider: 'Proveedor',
                related: 'Relacionado',
                resource: 'Recurso',
            },
            freeze_period: {
                placeholder: 'por ejemplo: 2h',
            },
            leeway: {
                fields: {
                    leeway_arrival: 'Margen de llegada',
                    leeway_departure: 'Margen de salida',
                },
                placeholders: {
                    leeway: 'p. ej. 30 (min)',
                },
            },
            logo: {
                description: 'Max 300px de alto, Max 300px de ancho',
            },
            name: 'Producto',
            notifications: {
                configuration: 'Hay configuraciones que faltan en este producto. Vaya a la página de configuración para ajustar la configuración del producto.',
                inactive: 'Este producto esta inactivo. Haga clic en el botón de activación para activar el producto.',
                product_missing_data: 'Hay datos de configuración o de recursos que faltan en este producto. Proporcione los datos y vuelva a intentar activar el producto.',
                'product-missing-data-for-enable': 'Hay datos de configuración o de recursos que faltan en este producto.',
                resource: 'Hay un recurso que falta en este producto. Ve a la página de recursos para ajustar el producto-recurso.',
                vat_percentage: 'A este producto le falta un porcentaje de IVA aplicado en las configuraciones del producto. Ve a la página de configuración para ajustar el porcentaje de IVA.',
            },
            number_of_persons: {
                placeholder: 'Número máximo de personas',
            },
            operational_times: {
                add: 'Agregar hora de operación',
                no_result: 'Este producto no tiene horas de operación.',
                save: 'Guardar horas de operación',
                title: 'Horas operativas',
            },
            occupancy: {
                graph: {
                    label: {
                        capacity: 'Capacidad',
                        hour: {
                            capacity: 'Capacidad por hora',
                            occupancy: 'Ocupación por hora',
                        },
                        occupancy: 'Ocupación',
                    },
                    no_results: 'No se ha reservado ningún producto en la fecha seleccionada.',
                    title: 'Ocupación',
                },
                reservations: {
                    destination_arrival_date: {
                        no_results: 'No se encontraron reservaciones de llegada para la fecha seleccionada.',
                        title: 'Reservaciones de llegada (%{count})',
                    },
                    destination_departure_date: {
                        no_results: 'No se encontraron reservaciones de salida para la fecha seleccionada.',
                        title: 'Reservaciones de salida (%{count})',
                    },
                    id: {
                        no_results: 'No se encontraron otras reservaciones para la fecha seleccionada.',
                        title: 'Otras reservaciones (%{count})',
                    },
                },
            },
            title: 'Productos',
            properties: {
                no_results: 'No hay propiedades agregadas a este producto.',
            },
            related: {
                add: 'Agregar un producto relacionado',
                delete: {
                    description: 'El artículo será eliminado permanentemente. Esta acción no se puede deshacer.',
                    title: '¿Estás seguro de que deseas eliminar esto?',
                },
                no_results: 'No hay productos relacionados',
                title: 'Relacionado',
            },
            require_one_of: {
                add: 'Agregar un producto relacionado requerido',
                no_result: 'No hay productos relacionados requeridos',
                title: 'Requerir uno de',
            },
            rules: 'Reglas',
            sales_price: {
                add: 'Agregar una propiedad con precio de venta',
                no_result: 'No hay configuraciones de precios de venta',
                title: 'Precio de venta',
            },
            pages: {
                location: 'Edita la ubicación: %{title}',
                resource: 'Editar el recurso: %{title}',
            },
            value: {
                add: 'Agregar un %{type}',
                label: 'Valor',
                no_result: 'No hay %{type} en esta configuración.',
                save: 'Reserva %{type}',
                title: 'Valor',
                types: {
                    dates: {
                        plural: 'fechas',
                        singular: 'fecha',
                    },
                    email_domain: {
                        plural: 'dominios de email',
                        singular: 'dominio de email',
                    },
                    time: {
                        plural: 'tiempos',
                        singular: 'tiempo',
                    },
                },
            },
            communicate_email_addresses: {
                placeholder: 'Elige si se deben comunicar las direcciones de correo electrónico',
                choices: {
                    do_not_send: 'No enviar',
                    send: 'Enviar',
                    send_masked: 'Enviar enmascarado',
                },
            },
            voucher_include_invoice: {
                placeholder: 'p. ej. sí o no',
            },
        },
        product_memberships: {
            actions: {
                create: 'Crear una membresía de producto',
                edit: 'Editar la membresía de producto',
            },
            create: {
                pricing: 'Utilizaremos el precio predeterminado de la membresía del producto si no actualiza el campo de precio.',
            },
            fields: {
                membership_schedule: 'Horario',
                price_ondemand: 'Precio bajo demanda',
                price_scheduled: 'Price programado',
                supports_ondemand: 'Soporta bajo demanda',
                supports_scheduled: 'Soporta programado',
                group_identifier: 'Identificador de grupo',
                product_membership_id: 'Membresía de producto',
                user_product_membership_pool_id: 'Grupo de membresía',
                user_vehicle_id: 'Vehículo',
                deferred: 'Diferido',
                payment_method_description: 'Por defecto, el método de pago está configurado en Factura. Si desea utilizar el pago diferido, marque la casilla a continuación.',
            },
            no_results: 'No hay membresías de productos',
            title: 'Membresías de productos',
        },
        profile: {
            name: 'Perfil',
        },
        properties: {
            actions: {
                create: 'Crea una propiedad',
                edit: 'Edita la propiedad',
                show: 'Propiedad: %{title}',
            },
            fields: {
                icon: 'Icono',
                name: 'Nombre',
                priority: 'Prioridad',
                property_group_id: 'Grupo de propiedades',
            },
            languages: {
                label: 'Seleccione un idioma disponiblee',
            },
            title: 'Propiedades',
            validate: {
                property_group_id: 'Ingrese un grupo de propiedades',
                'property-groups-not-available': 'El grupo de propiedades no está disponible.',
            },
        },
        propertygroups: {
            actions: {
                create: 'Crear un grupo de propiedades',
                edit: 'Editar el grupo de propiedades: %{title}',
                show: 'Grupo de propiedad: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'Nombre',
                properties: 'Propiedades',
                property: 'Propiedad',
            },
            languages: {
                label: 'Seleccione un idioma disponible',
            },
            name: 'Grupo de propiedades',
            plural: 'Grupos de propiedades',
        },
        reservations: {
            fields: {
                booking_order_id: 'ID de Mobian del cliente',
                cancelled_at: 'Cancelado a las',
                created_at: 'Creado',
                customer: 'Cliente',
                customer_remarks: 'Comentarios del cliente',
                destination_address: 'Punto de entrega',
                destination_arrival_date: 'Fecha de llegada',
                destination_departure_date: 'Fecha de salida',
                drop_off_date: 'Fecha de devolución',
                ending_at: 'Terminando en',
                flight_number: 'Número de vuelo',
                full_name: 'Nombre',
                internal_order_id: 'Solicitar ID',
                last_name: 'Apellido',
                license_plate: 'Placa',
                number_of_persons: 'Número de personas',
                origin_address: 'Lugar de recogida',
                phone: 'Teléfono',
                pick_up_date: 'Fecha de recogida',
                product: 'Producto',
                remote_reference: 'Referencia remota',
                return_flight_number: 'Número de vuelo de regreso',
                starting_at: 'A partir de',
                subscription_id: 'Suscripción ID',
                subscription_reservation_id: 'Reserva de suscripción ID',
                updated_at: 'Última actualización',
            },
            name: 'Reserva',
            open_barrier: {
                modal: {
                    error: 'Vaya, algo salió mal al abrir la barrera. Por favor, inténtalo de nuevo más tarde.',
                    force_not_allowed_for_access_method: 'La barrera no está permitida para este método de acceso.',
                    session_open_barrier_requires_access_point: 'La apertura de la barrera en esta sesión requiere un punto de acceso.',
                    success: 'La barrera se abrió correctamente.',
                },
                title: 'Abrir la barrera',
            },
            title: 'Reservaciones',
            session: {
                asset_not_usable: {
                    description: 'Puede volver a intentarlo con una detención forzada. Esto finalizará siempre la sesión y devolverá el recurso a «disponible» si la sesión se inició con uno.',
                    title: 'La detención de la sesión falló debido a los siguientes requisitos previos:',
                },
                button: {
                    end: 'Detener la sesión',
                    start: 'Iniciar la sesión',
                    open_barrier: 'Abrir la barrera',
                },
                modal: {
                    button: {
                        submit: {
                            end: 'Detener la sesión',
                            start: 'Iniciar la sesión',
                        },
                    },
                    callback: {
                        end: {
                            error: 'Vaya, algo salió mal al finalizar la sesión. Por favor, inténtelo de nuevo más tarde',
                            success: 'La sesión finalizó con éxito.',
                        },
                        start: {
                            error: 'Vaya, algo salió mal al iniciar la sesión. Por favor, inténtelo de nuevo más tarde',
                            success: 'La sesión se inició correctamente.',
                        },
                    },
                    checkbox: 'Abre la puerta',
                    description: {
                        end: 'La sesión de reserva actual ya ha comenzado. Haga clic en la casilla de verificación si desea abrir o cerrar la puerta.',
                        start: 'La sesión de reserva actual aún no ha comenzado. Haga clic en la casilla de verificación si desea abrir o cerrar la puerta.',
                    },
                    title: {
                        end: 'Detener la sesión',
                        start: 'Iniciar la sesión',
                    },
                },
            },
            show: {
                activities: {
                    access_sessions: {
                        title: 'Sesiones de acceso',
                        not_found: 'No se encontraron actividades de sesión de acceso para esta reserva',
                    },
                },
                booking_information: 'Infomación sobre reservas',
                product: 'Producto',
                reservation_details: 'Detalles de la reserva',
                reservation_price: 'Precio de la reserva',
                travel_details: 'Detalles de viaje',
            },
        },
        subcategories: {
            actions: {
                create: 'Crea una subcategoría',
                edit: 'Edita la subcategoría',
                show: 'Subcategoría: %{title}',
            },
            fields: {
                id: 'ID',
                name: 'nombre',
                category_id: 'categoría',
            },
            languages: {
                label: 'Seleccione un idioma disponible',
            },
            title: 'Subcategorias',
            validate: {
                'categories-not-available': 'No hay categorías disponibles.',
            },
        },
        subscriptions: {
            actions: {
                create: 'Crear',
                edit: 'Editar',
            },
            fields: {
                account: 'Cuenta',
                company_name: 'Nombre de empresa',
                currency: 'Moneda',
                email: 'Email',
                end_date: 'Fecha fin',
                first_name: 'Nombre',
                full_name: 'Nombre completo',
                last_name: 'Apellido',
                language: 'Lenguaje',
                license_plate: 'Placa',
                name: 'Nombre',
                order_id: 'Reserva',
                phone: 'Teléfono',
                price: 'Precio',
                start_date: 'Fecha inicio',
                status: 'Estado',
                terminated_at: 'Terminado en',
            },
            show: {
                subscription_details: 'Detalle de subscripción',
                subscription: 'Subscripción',
            },
            tooltips: {
                ok: 'Ok',
                pending: 'Subscripción: pendiente',
                under_review: 'Subscripción:por revisar',
            },
            title: 'Subscripciones',
        },
        subscriptionProducts: {
            create: {
                title: 'Añadir producto de suscripción',
            },
            fields: {
                end_time: 'Hora de finalización',
                start_time: 'Hora de inicio',
                day: 'Día',
                product: 'Producto',
            },
            input: {
                day: {
                    1: 'Lunes',
                    2: 'Martes',
                    3: 'Miércoles',
                    4: 'Jueves',
                    5: 'Viernes',
                    6: 'Sábado',
                    7: 'Domingo',
                },
            },
            no_results: 'No se encontraron productos de suscripción.',
            title: 'Productos de suscripción',
        },
        users: {
            actions: {
                activate: 'Activar',
                create: 'Crear un usuario',
                deactivate: 'Desactivar',
                edit: 'editar usuario',
                reset_password: 'Restablecer contraseña',
            },
            activity: {
                activate: {
                    title: 'El usuario se activará',
                    description: 'Cuando el usuario está activo, el usuario puede iniciar sesión en nuestros paneles, aplicaciones y usar nuestros servicios.',
                },
                deactivate: {
                    title: 'El usuario será desactivado',
                    description: 'Cuando el usuario está inactivo, el usuario ya no puede iniciar sesión en nuestros paneles, aplicaciones o usar nuestros servicios.',
                },
            },
            delete: {
                warnings: {
                    'user-has-active-memberships': 'Son membresías activas para este usuario.',
                    'user-has-active-subscriptions': 'Hay suscripciones activas para este usuario.',
                    'user-has-future-bookings': 'Hay reservas futuras para este usuario.',
                    'user-has-invoicable-bookings': 'Hay reservas facturables para este usuario.',
                    'user-has-open-invoices': 'Hay facturas abiertas para este usuario.',
                    'user-has-overdue-invoices': 'Hay facturas vencidas para este usuario.',
                    'user-has-recent-recurring-payment-activity': 'Hay actividad reciente de pagos recurrentes para este usuario.',
                    'user-has-wallet-funds': 'Son fondos en la cartera para este usuario.',
                },
            },
            fields: {
                active: 'Activo',
                address: 'Habla a',
                bic: 'BIC',
                city: 'Ciudad',
                company_email: 'Email de la empresa',
                company_name: 'Nombre de empresa',
                company_registration: 'Número COC',
                company_vat: 'Número de IVA',
                contract: 'Contrato',
                country: 'País',
                email: 'Email',
                external_yield: 'Rendimiento externo',
                firstname: 'Primer nombre',
                iban: 'IBAN',
                lastname: 'Apellido',
                locale: 'Local',
                logo: 'Logo',
                membership_id: 'Membresía',
                name: 'Nombre',
                orders: 'Pedidos',
                phonenumber: 'Teléfono',
                product_commission_reseller: 'Comisión de producto para revendedores',
                provider_id: 'Proveedor',
                reseller_id: 'Revendedores',
                role: 'Papel',
                title: 'Título',
                url: 'URL',
                user_id: 'Revendedores',
                username: 'Nombre de usuario',
                vat: 'IVA',
                yield_commission: 'Comisión de rendimiento',
                zipcode: 'Código postal',
            },
            filters: {
                active: {
                    active: 'Solo activo',
                    inactive: 'Solo inactivo',
                },
            },
            forms: {
                account: 'Cuenta',
                address: 'Habla a',
                company: 'Empresa',
                contact: 'Contacto',
                general: 'General',
                products: 'Últimos productos actualizados',
                registrations: 'Inscripciones',
            },
            memberships: {
                create: 'Creación de membresía de usuario',
                edit: 'Editar membresía de usuario (%{name})',
                no_results: 'No hay membresías vinculadas a este usuario',
                pricing: 'Precios',
            },
            name: 'Usuario',
            no_results: 'No se encontraron usuarios.',
            not_found: 'No se encontró ningún usuario.',
            notifications: {
                inactive: 'Este usuario está inactivo. Haga clic en el botón Activar para reactivar el usuario.',
                not_confirmed: 'Este usuario aún no ha confirmado su cuenta.',
            },
            products: {
                actions: {
                    list: 'Mostrar todos los productos (%{total})',
                },
            },
            // User-product-memberships create and edit
            product_memberships: {
                actions: {
                    create: 'Crear una membresía de producto de usuario',
                    edit: 'Editar la membresía de producto de usuario',
                },
            },
            title: 'Usuarios',
            reset_password: {
                description: 'Restablecer una contraseña enviará una nueva contraseña al correo electrónico del usuario. La contraseña antigua ya no será utilizable. Las sesiones actualmente iniciadas de este usuario requerirán que inicie sesión en todos los dispositivos con su nueva contraseña.',
                title: 'Restablecer la contraseña del usuario',
            },
            roles: {
                reseller: 'Revendedores',
                provider: 'Proveedor',
            },
        },
        wallets: {
            fields: {
                amount: 'Monto',
                balance: 'Saldo',
                reason: 'Motivo',
                type: 'Tipo',
            },
            no_results: 'No se encontró ninguna cartera.',
            title: 'Carteras',
            topup: {
                notifications: {
                    success: {
                        decrease: 'La cartera del usuario se redujo correctamente.',
                        increase: 'La cartera de usuarios se ha incrementado correctamente.',
                    },
                },
                label: 'Recarga',
                title: 'Recarga de cartera',
            },
        },
        webhooks: {
            actions: {
                create: 'Crear un Webhook',
                edit: 'Editar Webhook: %{title}',
            },
            fields: {
                action_booking_cancelled: 'Acción de Reserva Cancelada',
                action_booking_created: 'Acción de Reserva Creada',
                action_booking_initialised: 'Acción de Reserva Inicializada',
                action_booking_modified: 'Acción de Reserva Modificada',
                action_booking_under_review: 'Acción de Reserva En Revisión',
                action_reservation_cancelled: 'Acción de Reserva Cancelada',
                action_reservation_created: 'Acción de Reserva Creada',
                action_reservation_modified: 'Acción de Reserva Modificada',
                is_active: 'Activo',
                name: 'nom',
                url: 'url',
            },
            forms: {
                actions: 'Comportamiento',
                general: 'general',
            },
            title: 'Webhooks',
        },
    },
    page: {
        page_not_found: {
            title: 'Página no encontrada',
            description: 'No se puede encontrar la página que está buscando.',
        },
        resource_not_found: {
            description: 'No pudimos encontrar el recurso que busca.',
            title: 'Recurso no encontrado',
        },
        not_authorised: {
            title: 'Ups..',
            description: 'Parece que no estás autorizado para ver esta página.',
        },
    },
    release: {
        list: {
            description: 'En esta versión, actualizamos las imágenes de las páginas de listas. Eliminamos el botón Mostrar e hicimos posible desplazar el mouse y hacer clic en la fila para volver a la página de detalles de ese elemento específico.',
            title: 'Pequeña actualización de nuestras páginas de resumen',
        },
    },
    signUp: {
        errors: {
            passowrd_chars: 'La contraseña debe contener al menos 6 caracteres',
            same_email: 'Los correos electrónicos deben ser iguales',
            same_password: 'Las contraseñas deben ser iguales',
        },
        fields: {
            confirm_email: 'Confirmar correo',
            confirm_password: 'Confirmar contraseña',
        },
        no_account: 'No tengo una cuenta',
        title: 'Registrarse',
        success: 'El usuario se ha registrado correctamente',
    },
};



// WEBPACK FOOTER //
// ./src/i18n/es.js